import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
  type ComponentType,
  type ReactNode,
} from "react";
import { Link, useLocation, useRouterState } from "@tanstack/react-router";
import Activity from "lucide-react/dist/esm/icons/activity.js";
import AtSign from "lucide-react/dist/esm/icons/at-sign.js";
import Award from "lucide-react/dist/esm/icons/award.js";
import BadgeCheck from "lucide-react/dist/esm/icons/badge-check.js";
import BarChart3 from "lucide-react/dist/esm/icons/bar-chart-3.js";
import BedDouble from "lucide-react/dist/esm/icons/bed-double.js";
import BellRing from "lucide-react/dist/esm/icons/bell-ring.js";
import Book from "lucide-react/dist/esm/icons/book.js";
import BookCheck from "lucide-react/dist/esm/icons/book-check.js";
import BookMarked from "lucide-react/dist/esm/icons/book-marked.js";
import BookOpen from "lucide-react/dist/esm/icons/book-open.js";
import Bookmark from "lucide-react/dist/esm/icons/bookmark.js";
import Brain from "lucide-react/dist/esm/icons/brain.js";
import CalendarCheck from "lucide-react/dist/esm/icons/calendar-check.js";
import CalendarDays from "lucide-react/dist/esm/icons/calendar-days.js";
import Camera from "lucide-react/dist/esm/icons/camera.js";
import ChefHat from "lucide-react/dist/esm/icons/chef-hat.js";
import Check from "lucide-react/dist/esm/icons/check.js";
import ChevronDown from "lucide-react/dist/esm/icons/chevron-down.js";
import ClipboardList from "lucide-react/dist/esm/icons/clipboard-list.js";
import ClipboardPen from "lucide-react/dist/esm/icons/clipboard-pen.js";
import ClipboardPlus from "lucide-react/dist/esm/icons/clipboard-plus.js";
import CreditCard from "lucide-react/dist/esm/icons/credit-card.js";
import Download from "lucide-react/dist/esm/icons/download.js";
import Droplets from "lucide-react/dist/esm/icons/droplets.js";
import FileBarChart from "lucide-react/dist/esm/icons/file-bar-chart.js";
import FileText from "lucide-react/dist/esm/icons/file-text.js";
import Filter from "lucide-react/dist/esm/icons/filter.js";
import Flag from "lucide-react/dist/esm/icons/flag.js";
import Flame from "lucide-react/dist/esm/icons/flame.js";
import FlaskConical from "lucide-react/dist/esm/icons/flask-conical.js";
import Flower2 from "lucide-react/dist/esm/icons/flower-2.js";
import Folder from "lucide-react/dist/esm/icons/folder.js";
import Footprints from "lucide-react/dist/esm/icons/footprints.js";
import Gauge from "lucide-react/dist/esm/icons/gauge.js";
import GitCompare from "lucide-react/dist/esm/icons/git-compare.js";
import GraduationCap from "lucide-react/dist/esm/icons/graduation-cap.js";
import Handshake from "lucide-react/dist/esm/icons/handshake.js";
import Heart from "lucide-react/dist/esm/icons/heart.js";
import HeartPulse from "lucide-react/dist/esm/icons/heart-pulse.js";
import History from "lucide-react/dist/esm/icons/history.js";
import Home from "lucide-react/dist/esm/icons/home.js";
import Hourglass from "lucide-react/dist/esm/icons/hourglass.js";
import Images from "lucide-react/dist/esm/icons/images.js";
import KeyRound from "lucide-react/dist/esm/icons/key-round.js";
import LayoutDashboard from "lucide-react/dist/esm/icons/layout-dashboard.js";
import Library from "lucide-react/dist/esm/icons/library.js";
import LineChart from "lucide-react/dist/esm/icons/line-chart.js";
import ListChecks from "lucide-react/dist/esm/icons/list-checks.js";
import LogOut from "lucide-react/dist/esm/icons/log-out.js";
import MapIcon from "lucide-react/dist/esm/icons/map.js";
import Menu from "lucide-react/dist/esm/icons/menu.js";
import MessageSquare from "lucide-react/dist/esm/icons/message-square.js";
import MessagesSquare from "lucide-react/dist/esm/icons/messages-square.js";
import Mic from "lucide-react/dist/esm/icons/mic.js";
import Microscope from "lucide-react/dist/esm/icons/microscope.js";
import Newspaper from "lucide-react/dist/esm/icons/newspaper.js";
import NotebookPen from "lucide-react/dist/esm/icons/notebook-pen.js";
import PanelLeftClose from "lucide-react/dist/esm/icons/panel-left-close.js";
import PanelLeftOpen from "lucide-react/dist/esm/icons/panel-left-open.js";
import PersonStanding from "lucide-react/dist/esm/icons/person-standing.js";
import PieChart from "lucide-react/dist/esm/icons/pie-chart.js";
import Pill from "lucide-react/dist/esm/icons/pill.js";
import Receipt from "lucide-react/dist/esm/icons/receipt.js";
import Repeat from "lucide-react/dist/esm/icons/repeat.js";
import Salad from "lucide-react/dist/esm/icons/salad.js";
import ScrollText from "lucide-react/dist/esm/icons/scroll-text.js";
import Search from "lucide-react/dist/esm/icons/search.js";
import Settings from "lucide-react/dist/esm/icons/settings.js";
import Shield from "lucide-react/dist/esm/icons/shield.js";
import Smile from "lucide-react/dist/esm/icons/smile.js";
import Sparkles from "lucide-react/dist/esm/icons/sparkles.js";
import Stethoscope from "lucide-react/dist/esm/icons/stethoscope.js";
import Sun from "lucide-react/dist/esm/icons/sun.js";
import Sunrise from "lucide-react/dist/esm/icons/sunrise.js";
import Tablets from "lucide-react/dist/esm/icons/tablets.js";
import Tag from "lucide-react/dist/esm/icons/tag.js";
import TestTube from "lucide-react/dist/esm/icons/test-tube.js";
import Thermometer from "lucide-react/dist/esm/icons/thermometer.js";
import TrendingUp from "lucide-react/dist/esm/icons/trending-up.js";
import Trophy from "lucide-react/dist/esm/icons/trophy.js";
import Upload from "lucide-react/dist/esm/icons/upload.js";
import User from "lucide-react/dist/esm/icons/user.js";
import UserCog from "lucide-react/dist/esm/icons/user-cog.js";
import UserRoundCheck from "lucide-react/dist/esm/icons/user-round-check.js";
import UserSearch from "lucide-react/dist/esm/icons/user-search.js";
import Users from "lucide-react/dist/esm/icons/users.js";
import UsersRound from "lucide-react/dist/esm/icons/users-round.js";
import Utensils from "lucide-react/dist/esm/icons/utensils.js";
import Video from "lucide-react/dist/esm/icons/video.js";
import Wind from "lucide-react/dist/esm/icons/wind.js";
import Zap from "lucide-react/dist/esm/icons/zap.js";
import { useTranslation } from "react-i18next";

import { Avatar, AvatarFallback } from "@shared/ui/avatar";
import { Button } from "@shared/ui/button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@shared/ui/collapsible";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@shared/ui/dropdown-menu";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@shared/ui/sheet";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  useCloseTooltipsOnRouteChange,
} from "@shared/ui/tooltip";
import { brand, brandAssetPath } from "@shared/config";
import { activeLanguagePrefix } from "@shared/lib/localized-path";
import { cn } from "@shared/lib/utils";
import { usePaymentConfig } from "@shared/hooks/use-paywall";
// One table, three consumers (this nav filter, the router guard in
// `frontend/src/main.tsx`, and the tests). Private copies drift, and a drifted
// copy shows a nav item that routes straight to a redirect.
import {
  AI_FEATURE_ROUTE_PREFIXES as AI_FEATURE_PATH_MAP,
  BYOK_ROUTE_PREFIXES as BYOK_PATH_PREFIXES,
  MONEY_ROUTE_PREFIXES as PAYWALLED_PATH_PREFIXES,
  REMOVED_SUBSCRIPTION_ROUTE_PREFIXES as REMOVED_SUBSCRIPTION_PATH_PREFIXES,
} from "@shared/lib/paywall";
import { useSiteFeatureFlags } from "@shared/hooks/use-site-feature-flags";
import { useLandingPath } from "@shared/hooks/use-site-feature-flags/useLandingPath";
import {
  filterRoutesByFeatures,
  getConfiguredFeatureRoutes,
  type SiteFeatureFlags,
} from "@shared/lib/site-features";
import { CommandMenu } from "@shared/components/command-menu";
import {
  LanguageMenu,
  SearchTrigger,
  ThemeMenu,
  isSupportedLanguage,
  stripLanguagePrefix,
  translateWithFallback,
} from "../shared/header-controls";
import { getNavGroupKey } from "./sidebar-preferences";
import { useSidebarPreferences } from "./sidebar-preferences-query";
import { ChatNavBadge } from "@apps/community_chat/frontend/components/ChatNavBadge";

const NAV_BADGE_MAP: Record<string, ComponentType> = {
  "/messages": ChatNavBadge,
};

function stripRouteLanguagePrefix(pathname: string): string {
  if (pathname === "/:lang") return "/";
  if (pathname.startsWith("/:lang/")) {
    return pathname.slice("/:lang".length) || "/";
  }
  return stripLanguagePrefix(pathname);
}

function pathStartsWithPrefix(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

/**
 * Drop routes whose surface does not exist on this deployment.
 *
 * Money and AI are filtered by different switches on purpose:
 *
 * - **money** (`/pricing`, `/checkout`, `/wallet`) — `paymentsEnabled` only.
 *   BYOK must never surface a wallet on a deployment that has nothing to sell.
 * - **AI** — either switch, plus the per-feature flag. A user needs to *find*
 *   the feature before they can learn it wants a key, so an AI nav item shows
 *   whenever the feature exists here, regardless of whether this particular
 *   user has a key yet. The page itself renders the unlock CTA.
 * - **`/settings/ai-keys`** — `byokEnabled` only. Pointless where nobody can
 *   bring a key.
 *
 * `byokEnabled` defaults to `false` so an un-updated caller keeps the exact
 * pre-BYOK behaviour.
 */
export function filterRoutesByPaywall(
  routes: readonly SystemRoute[],
  paymentsEnabled: boolean,
  aiFeaturesEnabled: Record<string, boolean>,
  byokEnabled = false,
): readonly SystemRoute[] {
  const aiSurfacesExist = paymentsEnabled || byokEnabled;
  return routes.filter((route) => {
    const routePath = stripRouteLanguagePrefix(route.path);
    if (REMOVED_SUBSCRIPTION_PATH_PREFIXES.some((prefix) => pathStartsWithPrefix(routePath, prefix))) {
      return false;
    }
    if (
      !paymentsEnabled &&
      PAYWALLED_PATH_PREFIXES.some((prefix) => pathStartsWithPrefix(routePath, prefix))
    ) {
      return false;
    }
    if (
      !byokEnabled &&
      BYOK_PATH_PREFIXES.some((prefix) => pathStartsWithPrefix(routePath, prefix))
    ) {
      return false;
    }
    for (const [prefix, featureKey] of Object.entries(AI_FEATURE_PATH_MAP)) {
      if (!pathStartsWithPrefix(routePath, prefix)) continue;
      if (!aiSurfacesExist || !aiFeaturesEnabled[featureKey]) return false;
    }
    return true;
  });
}

/**
 * Drop routes whose site feature is not enabled. Reads the generated
 * `route.feature` directly (one table, generated from the backend registry).
 * Fail closed: a route with a `feature` shows only when its flag is exactly
 * `true`, so a missing / not-yet-loaded map hides it. Core routes (and routes
 * with no `feature`) are never affected.
 */
export function filterRoutesByFeatureFlags(
  routes: readonly SystemRoute[],
  flags: SiteFeatureFlags | null | undefined,
): readonly SystemRoute[] {
  return filterRoutesByFeatures(routes, flags);
}

export interface SystemRoute {
  path: string;
  name: string;
  authRequired: boolean;
  layout: string;
  navLabel?: string;
  navGroup?: string;
  navIcon?: string;
  navOrder?: number;
  showInNav?: boolean;
  adminOnly?: boolean;
  /**
   * When true the dashboard shell renders the page edge-to-edge with no main
   * padding and hides the footer so the page owns its viewport (chat surfaces).
   */
  navFullBleed?: boolean;
  /** Site feature gating the route (generated; never set with `core`). */
  feature?: string;
  /** Core surface — never flaggable. */
  core?: boolean;
  landingPriority?: number;
}

export interface SystemUser {
  id?: string;
  email?: string;
  name?: string;
  role?: string;
  isStaff?: boolean;
  isSuperuser?: boolean;
}

export interface SystemShellProps {
  children: ReactNode;
  routes: readonly SystemRoute[];
  currentRoute?: SystemRoute;
  user?: SystemUser | null;
  onLogout?: () => void;
  variant?: "dashboard" | "public";
  /** Optional slot rendered in the header next to ThemeMenu / LanguageMenu / UserMenu. */
  headerExtra?: ReactNode;
}

export interface NavItem {
  href: string;
  name: string;
  label: string;
  group: string;
  groupKey: string;
  icon: ComponentType<{ className?: string }>;
  order: number;
}

export interface NavGroup {
  key: string;
  label: string;
  icon: ComponentType<{ className?: string }>;
  items: NavItem[];
  itemCount: number;
  order: number;
}

export interface SystemShellContextValue {
  routes: readonly SystemRoute[];
  user?: SystemUser | null;
  sidebarGroups: NavGroup[];
  /** Standalone nav items (Health Assistant, Voice Log) that live outside any group. */
  standaloneItems: NavItem[];
  sidebarHiddenGroups: string[];
  sidebarPreferencesLoading: boolean;
  refreshSidebarPreferences: () => Promise<void>;
  updateSidebarHiddenGroups: (hiddenGroups: readonly string[]) => Promise<void>;
}

export interface SystemSidebarProps {
  items: readonly NavItem[];
  pathname: string;
  className?: string;
  collapsible?: boolean;
  defaultCollapsed?: boolean;
  persistCollapsed?: boolean;
}

const SystemShellContext = createContext<SystemShellContextValue>({
  routes: [],
  user: null,
  sidebarGroups: [],
  standaloneItems: [],
  sidebarHiddenGroups: [],
  sidebarPreferencesLoading: false,
  refreshSidebarPreferences: () => Promise.resolve(),
  updateSidebarHiddenGroups: () => Promise.resolve(),
});

export function useSystemShell(): SystemShellContextValue {
  return useContext(SystemShellContext);
}

const iconMap: Record<string, ComponentType<{ className?: string }>> = {
  // Legacy / generic keys kept for backwards compatibility.
  activity: Activity,
  ai: Brain,
  analytics: BarChart3,
  book: Book,
  billing: CreditCard,
  bookmark: Bookmark,
  check: Check,
  community: Users,
  diet: Utensils,
  files: Folder,
  home: Home,
  knowledge: BookOpen,
  medical: Stethoscope,
  profile: User,
  search: Search,
  settings: Settings,
  shield: Shield,
  supplements: Pill,
  symptoms: HeartPulse,
  treatments: ClipboardList,
  users: Users,
  waitlist: Hourglass,
  "at-sign": AtSign,

  // Overview group.
  dashboard: LayoutDashboard,
  exports: Download,

  // Tracking group.
  "body-map": PersonStanding,
  conditions: ClipboardPlus,
  checkin: CalendarCheck,
  experiments: FlaskConical,
  flareups: Thermometer,
  "symptom-history": History,
  "symptom-log": NotebookPen,
  "symptom-photos": Camera,
  "voice-log": Mic,

  // Treatment group.
  coimbra: Sun,
  "cost-tracker": Receipt,
  effectiveness: TrendingUp,
  "log-treatment": ClipboardPen,
  recommendations: Sparkles,
  reminders: BellRing,
  "supplement-log": ListChecks,
  thiamine: Zap,
  "treatment-history": ScrollText,

  // Insights group.
  "ai-insights": Brain,
  badges: Award,
  coaching: MessagesSquare,
  "message-square": MessageSquare,
  compare: GitCompare,
  milestones: Trophy,
  patterns: LineChart,
  "progress-photos": Images,
  reports: FileBarChart,
  streaks: Flame,

  // Diet group.
  "diet-dashboard": Salad,
  electrolytes: Droplets,
  elimination: Filter,
  "fat-ratio": PieChart,
  "food-log": Utensils,
  "meal-planner": CalendarDays,
  protocols: MapIcon,

  // Lifestyle group.
  activities: Footprints,
  lifestyle: Activity,
  "lifestyle-milestones": Flag,
  meditation: Flower2,
  mood: Smile,
  sleep: BedDouble,
  stress: Wind,

  // Medical group.
  "doctor-visits": UserRoundCheck,
  "lab-results": TestTube,
  medications: Tablets,
  "medical-reports": FileText,

  // Community group.
  "community-search": UserSearch,
  gratitude: Heart,
  "hope-feed": Sunrise,
  mentions: AtSign,
  "mentor-matches": Handshake,
  mentors: GraduationCap,
  moderation: Shield,
  recipes: ChefHat,
  saved: Bookmark,
  "similar-users": UsersRound,
  stories: Newspaper,

  // Learn / Knowledge group.
  books: Library,
  "protocol-guides": BookMarked,
  "reading-lists": BookCheck,
  studies: Microscope,
  videos: Video,

  // Account group.
  subscription: Repeat,
  "upload-file": Upload,
  usage: Gauge,

  // Admin group.
  "admin-users": UserCog,
  permissions: KeyRound,
  roles: BadgeCheck,

  // Public group.
  pricing: Tag,
};

/** Skip-link target: the sidebar `<nav>`. */
export const SIDEBAR_NAV_ID = "main-navigation";
const SYSTEM_SIDEBAR_COLLAPSED_STORAGE_KEY = "system-sidebar-collapsed";
const SYSTEM_SIDEBAR_EXPANDED_STORAGE_KEY = "sidebar.expanded";

function readSidebarCollapsedPreference(defaultCollapsed: boolean): boolean {
  if (typeof window === "undefined") return defaultCollapsed;

  try {
    const stored = window.localStorage.getItem(SYSTEM_SIDEBAR_COLLAPSED_STORAGE_KEY);
    if (stored === "true") return true;
    if (stored === "false") return false;
  } catch {
    return defaultCollapsed;
  }

  return defaultCollapsed;
}

function readSidebarExpandedPreference(initialGroupKey: string | null): string[] {
  const fallback = initialGroupKey ? [initialGroupKey] : [];
  if (typeof window === "undefined") return fallback;

  try {
    const stored = window.localStorage.getItem(SYSTEM_SIDEBAR_EXPANDED_STORAGE_KEY);
    if (stored) {
      const parsed = JSON.parse(stored);
      if (Array.isArray(parsed) && parsed.length > 0) {
        return [String(parsed[0])];
      }
    }
  } catch {
    return fallback;
  }

  return fallback;
}

function getPathLanguage(pathname: string): string | null {
  const firstSegment = pathname.split("/").filter(Boolean)[0];
  return isSupportedLanguage(firstSegment) ? firstSegment ?? null : null;
}

export function localizeHref(href: string, pathname: string): string {
  const prefix = activeLanguagePrefix(pathname);
  if (!prefix || href === "/" || href === prefix || href.startsWith(`${prefix}/`)) {
    return href;
  }
  return `${prefix}${href}`;
}

function getRouteTranslationKey(routeName: string): string {
  return `navigation.routes.${routeName.replace(/-i18n$/, "")}`;
}

function getGroupTranslationKey(groupKey: string): string {
  return `navigation.groups.${groupKey}`;
}

const ROUTE_LABEL_FALLBACKS: Record<string, Record<string, string>> = {
  "download-app": {
    en: "Get the App",
    ar: "احصل على التطبيق",
    de: "App herunterladen",
    es: "Obtener la aplicación",
    fr: "Obtenir l’application",
  },
};

export function getLocalizedRouteLabelFallback(
  routeName: string,
  defaultValue: string,
  pathname: string,
): string {
  const routeKey = canonicalRouteName(routeName);
  const language = activeLanguagePrefix(pathname).slice(1) || "en";
  return ROUTE_LABEL_FALLBACKS[routeKey]?.[language] ?? defaultValue;
}

function labelFromRoute(route: SystemRoute): string {
  if (route.navLabel) return route.navLabel;
  return route.name
    .replace(/-i18n$/, "")
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

function canonicalRouteName(routeName: string): string {
  return routeName.replace(/-i18n$/, "");
}

function labelFromSegment(segment: string): string {
  if (segment.startsWith(":") || segment.length > 20) return "";
  return segment
    .split("-")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function isAdminUser(user?: SystemUser | null): boolean {
  if (!user) return false;

  const role = user.role?.toLowerCase();
  return Boolean(
    user.isStaff ||
      user.isSuperuser ||
      role === "admin" ||
      role === "superadmin" ||
      role === "super_admin" ||
      role === "staff",
  );
}

function isAdminRoute(route: SystemRoute): boolean {
  return route.adminOnly === true || route.navGroup?.toLowerCase() === "admin";
}

export function buildNavItems(
  routes: readonly SystemRoute[],
  layout: string,
  user?: SystemUser | null,
  hiddenGroupKeys: readonly string[] = [],
): NavItem[] {
  const canSeeAdmin = isAdminUser(user);
  const hiddenGroups = new Set(hiddenGroupKeys);

  return routes
    .filter((route) => route.layout === layout && route.showInNav === true)
    .filter((route) => !route.path.startsWith("/:lang"))
    .filter((route) => !isAdminRoute(route) || canSeeAdmin)
    .map((route) => {
      const group = route.navGroup ?? "General";
      return {
        href: route.path,
        name: canonicalRouteName(route.name),
        label: labelFromRoute(route),
        group,
        groupKey: getNavGroupKey(group),
        icon: iconMap[route.navIcon ?? "home"] ?? Home,
        order: route.navOrder ?? 1000,
      };
    })
    .filter((item) => !hiddenGroups.has(item.groupKey))
    .sort((a, b) => a.order - b.order || a.label.localeCompare(b.label));
}

export function filterNavItemsByHiddenGroups(
  items: readonly NavItem[],
  hiddenGroupKeys: readonly string[],
): NavItem[] {
  const hiddenGroups = new Set(hiddenGroupKeys);
  return items.filter((item) => !hiddenGroups.has(item.groupKey));
}

export const STANDALONE_NAV_GROUP_KEY = "standalone";

export function isStandaloneNavItem(item: NavItem): boolean {
  return item.groupKey === STANDALONE_NAV_GROUP_KEY;
}

export function buildStandaloneNavItems(items: readonly NavItem[]): NavItem[] {
  return items
    .filter(isStandaloneNavItem)
    .slice()
    .sort((a, b) => a.order - b.order || a.label.localeCompare(b.label));
}

export function buildNavGroups(items: readonly NavItem[]): NavGroup[] {
  const groups = new Map<string, NavGroup>();
  for (const item of items) {
    if (isStandaloneNavItem(item)) continue;
    const group = groups.get(item.groupKey);
    if (group) {
      group.items.push(item);
      group.itemCount += 1;
      group.order = Math.min(group.order, item.order);
    } else {
      groups.set(item.groupKey, {
        key: item.groupKey,
        label: item.group,
        icon: item.icon,
        items: [item],
        itemCount: 1,
        order: item.order,
      });
    }
  }
  return Array.from(groups.values()).sort(
    (a, b) => a.order - b.order || a.label.localeCompare(b.label),
  );
}

export interface VisibleRoutesOptions {
  /** Routes to filter; defaults to the generated table registered at boot. */
  routes?: readonly SystemRoute[];
  layout?: string;
  user?: SystemUser | null;
  /** Load the user's hidden sidebar groups (dashboard surfaces only). */
  withSidebarPreferences?: boolean;
}

export interface VisibleRoutes {
  /** Routes that pass the feature flags and the paywall/BYOK layer. */
  routes: readonly SystemRoute[];
  /** Every nav item the user may see (admin applied, hidden groups not). */
  allItems: NavItem[];
  /** Nav items after the user's hidden groups. */
  items: NavItem[];
  /** Groups with ≥1 visible route — a group whose last route is hidden vanishes. */
  groups: NavGroup[];
  standaloneItems: NavItem[];
  hiddenGroups: string[];
  hiddenGroupsLoading: boolean;
  updateHiddenGroups: (hiddenGroups: readonly string[]) => Promise<void>;
  refreshHiddenGroups: () => Promise<void>;
}

/**
 * The one navigation pipeline: feature flags → paywall/BYOK → admin → the
 * user's hidden groups, memoized per input. Every surface that lists links
 * (desktop sidebar, mobile menu, command palette, Settings "Sidebar" tab,
 * onboarding) reads this instead of re-deriving its own list, so a disabled
 * feature disappears from all of them at once.
 */
export function useVisibleRoutes({
  routes: sourceRoutes,
  layout = "dashboard",
  user,
  withSidebarPreferences = layout === "dashboard",
}: VisibleRoutesOptions = {}): VisibleRoutes {
  const { data: paymentConfig } = usePaymentConfig();
  const { data: featureFlags } = useSiteFeatureFlags();
  const base = sourceRoutes ?? (getConfiguredFeatureRoutes() as readonly SystemRoute[]);
  const routes = useMemo(
    () =>
      filterRoutesByPaywall(
        filterRoutesByFeatureFlags(base, featureFlags),
        Boolean(paymentConfig?.paymentsEnabled),
        paymentConfig?.aiFeaturesEnabled ?? {},
        Boolean(paymentConfig?.byokEnabled),
      ),
    [
      base,
      featureFlags,
      paymentConfig?.paymentsEnabled,
      paymentConfig?.aiFeaturesEnabled,
      paymentConfig?.byokEnabled,
    ],
  );
  const preferences = useSidebarPreferences(user?.id, {
    enabled: withSidebarPreferences,
  });
  const allItems = useMemo(
    () => buildNavItems(routes, layout, user),
    [routes, layout, user],
  );
  const items = useMemo(
    () => filterNavItemsByHiddenGroups(allItems, preferences.hiddenGroups),
    [allItems, preferences.hiddenGroups],
  );
  const groups = useMemo(() => buildNavGroups(allItems), [allItems]);
  const standaloneItems = useMemo(
    () => buildStandaloneNavItems(allItems),
    [allItems],
  );
  return {
    routes,
    allItems,
    items,
    groups,
    standaloneItems,
    hiddenGroups: preferences.hiddenGroups,
    hiddenGroupsLoading: preferences.isLoading,
    updateHiddenGroups: preferences.updateHiddenGroups,
    refreshHiddenGroups: preferences.refresh,
  };
}

function isActiveNavItem(activePath: string, href: string): boolean {
  return activePath === href || (href !== "/" && activePath.startsWith(`${href}/`));
}

function getActiveNavItem(
  items: readonly NavItem[],
  activePath: string,
): NavItem | null {
  let activeItem: NavItem | null = null;

  for (const item of items) {
    if (
      isActiveNavItem(activePath, item.href) &&
      (!activeItem || item.href.length > activeItem.href.length)
    ) {
      activeItem = item;
    }
  }

  return activeItem;
}

interface BreadcrumbItem {
  href: string;
  label: string;
  translationKey?: string;
}

function routeLabelForPath(
  routes: readonly SystemRoute[],
  pathname: string,
): BreadcrumbItem | null {
  const normalizedPath = stripLanguagePrefix(pathname);
  const route = routes.find((candidate) => candidate.path === normalizedPath);
  return route
    ? {
        href: normalizedPath,
        label: labelFromRoute(route),
        translationKey: getRouteTranslationKey(route.name),
      }
    : null;
}

function buildBreadcrumbs(
  routes: readonly SystemRoute[],
  pathname: string,
): BreadcrumbItem[] {
  const normalizedPath = stripLanguagePrefix(pathname);
  const segments = normalizedPath.split("/").filter(Boolean);
  const crumbs: BreadcrumbItem[] = [
    { href: "/", label: "Home", translationKey: "navigation.home" },
  ];

  for (let index = 0; index < segments.length; index += 1) {
    const href = `/${segments.slice(0, index + 1).join("/")}`;
    const routeLabel = routeLabelForPath(routes, href);
    const label = routeLabel?.label ?? labelFromSegment(segments[index] ?? "");
    if (label) {
      crumbs.push({
        href,
        label,
        translationKey: routeLabel?.translationKey,
      });
    }
  }

  return crumbs;
}

function getUserInitials(user?: SystemUser | null): string {
  const source = user?.name || user?.email || "User";
  const words = source.split(/\s|@/).filter(Boolean);
  return words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join("");
}

function BrandLink({
  className,
  showText = true,
}: {
  className?: string;
  showText?: boolean;
}) {
  const assetBase = import.meta.env.BASE_URL;
  const { pathname } = useLocation();

  return (
	    <Link
	      to={localizeHref("/diet-protocols", pathname) as never}
	      className={cn(
	        "flex min-h-11 min-w-11 items-center gap-3 font-semibold text-foreground",
	        className,
	      )}
	    >
      <span className="relative flex h-9 w-9 shrink-0 items-center justify-center overflow-hidden rounded-md">
        <img
          src={brandAssetPath(assetBase, brand.assets.logoIcon)}
          alt=""
          className="absolute inset-0 h-full w-full object-contain dark:hidden"
          aria-hidden="true"
        />
        <img
          src={brandAssetPath(assetBase, brand.assets.logoDarkIcon)}
          alt=""
          className="absolute inset-0 hidden h-full w-full object-contain dark:block"
          aria-hidden="true"
        />
      </span>
	      <span className={cn("truncate", !showText && "sr-only")}>{brand.name}</span>
	    </Link>
	  );
	}

function UserMenu({ user, onLogout }: { user?: SystemUser | null; onLogout?: () => void }) {
  const { t } = useTranslation("common");
  const { pathname } = useLocation();
  const displayName = user?.name || user?.email || t("actions.user.fallbackName", "User");
  const menuLabel = translateWithFallback(t, "navigation.userMenu", "Account menu");
  // The visible label is the user's name (md+), so the accessible name must
  // contain it (WCAG 2.5.3 Label in Name).
  const triggerLabel = translateWithFallback(
    t,
    "navigation.userMenuFor",
    `Account menu: ${displayName}`,
    { name: displayName },
  );

  return (
    <Tooltip>
      <DropdownMenu modal={false}>
        <TooltipTrigger asChild>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              className="h-11 min-w-0 gap-2 px-2"
              aria-label={triggerLabel}
            >
              <Avatar className="h-8 w-8">
                <AvatarFallback className="text-xs font-medium">
                  {getUserInitials(user)}
                </AvatarFallback>
              </Avatar>
              <span className="hidden max-w-32 truncate text-sm md:inline">{displayName}</span>
              <ChevronDown className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
            </Button>
          </DropdownMenuTrigger>
        </TooltipTrigger>
        <DropdownMenuContent align="end" className="w-64">
          <DropdownMenuLabel>
            <span className="block truncate text-sm font-medium">{displayName}</span>
            {user?.email && (
              <span className="block truncate text-xs font-normal text-muted-foreground">
                {user.email}
              </span>
            )}
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem asChild>
            <Link to={localizeHref("/profile", pathname) as never}>
              <User className="me-2 h-4 w-4" />
              {t("navigation.profile", "Profile")}
            </Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to={localizeHref("/settings", pathname) as never}>
              <Settings className="me-2 h-4 w-4" />
              {t("navigation.settings", "Settings")}
            </Link>
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={onLogout} className="text-destructive focus:text-destructive">
            <LogOut className="me-2 h-4 w-4" />
            {t("navigation.logout", "Log out")}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <TooltipContent side="bottom">{menuLabel}</TooltipContent>
    </Tooltip>
  );
}

export function SystemSidebar({
  items,
  pathname,
  className,
  collapsible = true,
  defaultCollapsed = false,
  persistCollapsed = false,
}: SystemSidebarProps) {
  const { t, i18n } = useTranslation("common");
  const groupedItems = buildNavGroups(items);
  const standaloneItems = buildStandaloneNavItems(items);
  const activePath = stripLanguagePrefix(pathname);
  const activeItem = getActiveNavItem(items, activePath);
  const pendingPath = useRouterState({
    select: (s) =>
      s.status === "pending" ? stripLanguagePrefix(s.location.pathname) : null,
  });
  const activeGroupKey = activeItem?.groupKey ?? null;
  const currentLanguage = i18n.language?.split("-")[0] ?? getPathLanguage(pathname) ?? "en";
  // The rail sits at the inline-start edge, so its tooltips open toward the
  // inline-end side: right in LTR, left in RTL (Radix sides are physical).
  const isRtl =
    currentLanguage === "ar" ||
    (typeof document !== "undefined" && document.documentElement.dir === "rtl");
  const tooltipSide = isRtl ? "left" : "right";
  // A nav item that owns the current URL as a descendant (e.g. "Health
  // Assistant" while on /health-assistant/voice-log) but is not the best match.
  const isAncestorOfActive = (href: string): boolean =>
    activeItem?.href !== href && isActiveNavItem(activePath, href);
  // Only the active group is open by default; a persisted expansion is used
  // solely when no group owns the current route.
  const [openGroupKeys, setOpenGroupKeys] = useState<string[]>(() =>
    activeGroupKey ? [activeGroupKey] : readSidebarExpandedPreference(null),
  );
  const lastSyncedActiveGroupRef = useRef<string | null>(activeGroupKey);
  const [collapsed, setCollapsed] = useState(() =>
    persistCollapsed
      ? readSidebarCollapsedPreference(defaultCollapsed)
      : defaultCollapsed,
  );
  const isCollapsed = collapsible && collapsed;
  const SidebarToggleIcon = isCollapsed ? PanelLeftOpen : PanelLeftClose;

  useEffect(() => {
    // Accordion behaviour: only re-sync when the active route's group itself
    // transitions. Excluding openGroupKeys from the deps is intentional —
    // including it would overwrite user toggles on every render.
    if (activeGroupKey && lastSyncedActiveGroupRef.current !== activeGroupKey) {
      lastSyncedActiveGroupRef.current = activeGroupKey;
      setOpenGroupKeys([activeGroupKey]);
    }
  }, [activeGroupKey]);

  useEffect(() => {
    if (!collapsible || !persistCollapsed || typeof window === "undefined") return;

    try {
      window.localStorage.setItem(
        SYSTEM_SIDEBAR_COLLAPSED_STORAGE_KEY,
        collapsed ? "true" : "false",
      );
    } catch {
      return;
    }
  }, [collapsed, collapsible, persistCollapsed]);

  useEffect(() => {
    if (typeof window === "undefined") return;

    try {
      window.localStorage.setItem(
        SYSTEM_SIDEBAR_EXPANDED_STORAGE_KEY,
        JSON.stringify(openGroupKeys),
      );
    } catch {
      return;
    }
  }, [openGroupKeys]);

  const setGroupOpen = useCallback((groupKey: string, open: boolean) => {
    // Accordion behaviour: opening a group makes it the only open one;
    // closing leaves all groups collapsed.
    setOpenGroupKeys(open ? [groupKey] : []);
  }, []);

  return (
    <aside
      className={cn(
        "flex h-full flex-col border-e bg-card transition-[width] duration-200",
        isCollapsed ? "w-20" : collapsible ? "w-72" : "w-full",
        className,
      )}
      data-state={isCollapsed ? "collapsed" : "expanded"}
    >
      <div
        className={cn(
          "flex h-16 items-center border-b",
          isCollapsed ? "justify-center px-2" : "px-4",
        )}
      >
        {!isCollapsed && <BrandLink className="flex-1" />}
        {collapsible && (
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className={cn(!isCollapsed && "ms-2 shrink-0")}
            aria-label={
              isCollapsed
                ? translateWithFallback(t, "actions.sidebar.expand", "Expand sidebar")
                : translateWithFallback(t, "actions.sidebar.collapse", "Collapse sidebar")
            }
            aria-controls={SIDEBAR_NAV_ID}
            aria-expanded={!isCollapsed}
            onClick={() => setCollapsed((current) => !current)}
          >
            <SidebarToggleIcon className="h-4 w-4 rtl:scale-x-[-1]" />
          </Button>
        )}
      </div>
      <nav
        id={SIDEBAR_NAV_ID}
        tabIndex={-1}
        className="flex-1 overflow-y-auto px-3 py-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary"
        aria-label={translateWithFallback(
          t,
          "navigation.dashboardNavigation",
          "Dashboard navigation",
        )}
      >
        {isCollapsed ? (
          <TooltipProvider>
            <div className="space-y-2">
              {items.map((item) => {
                const Icon = item.icon;
                const localizedHref = localizeHref(item.href, pathname);
                const active = activeItem?.href === item.href;
                const itemLabel = translateWithFallback(
                  t,
                  getRouteTranslationKey(item.name),
                  getLocalizedRouteLabelFallback(item.name, item.label, pathname),
                );

                const isPending = Boolean(pendingPath && isActiveNavItem(pendingPath, item.href));
                const isParent = !active && isAncestorOfActive(item.href);
                return (
                  <Tooltip key={item.href}>
                    <TooltipTrigger asChild>
                      <Link
                        to={localizedHref as never}
                        aria-label={itemLabel}
                        aria-current={active ? "page" : isParent ? "true" : undefined}
                        data-pending={isPending || undefined}
                        className={cn(
                          "flex min-h-11 w-11 items-center justify-center rounded-md transition-colors",
                          active || isPending
                            ? "bg-primary/20 text-foreground"
                            : isParent
                              ? "border border-dashed border-primary/60 text-foreground hover:bg-accent"
                              : "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
                        )}
                      >
                        <Icon className="h-4 w-4 shrink-0" />
                      </Link>
                    </TooltipTrigger>
                    <TooltipContent side={tooltipSide} align="center">
                      {itemLabel}
                    </TooltipContent>
                  </Tooltip>
                );
              })}
            </div>
          </TooltipProvider>
        ) : (
          <div className="space-y-2">
            {standaloneItems.length > 0 && (
              <div className="mb-3 space-y-1 border-b pb-3">
                {standaloneItems.map((item) => {
                  const Icon = item.icon;
                  const localizedHref = localizeHref(item.href, pathname);
                  const active = activeItem?.href === item.href;
                  // Parent of the current leaf: "true" (in the current
                  // branch), never "page" — that belongs to the leaf alone.
                  const isParent = !active && isAncestorOfActive(item.href);
                  const itemLabel = translateWithFallback(
                    t,
                    getRouteTranslationKey(item.name),
                    getLocalizedRouteLabelFallback(item.name, item.label, pathname),
                  );
                  const isItemPending = Boolean(
                    pendingPath && isActiveNavItem(pendingPath, item.href),
                  );
                  const ItemBadge = NAV_BADGE_MAP[item.href];
                  return (
                    <Link
                      key={item.href}
                      to={localizedHref as never}
                      aria-current={active ? "page" : isParent ? "true" : undefined}
                      data-pending={isItemPending || undefined}
                      className={cn(
                        "flex min-h-11 items-center gap-3 rounded-md px-3 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary",
                        active || isItemPending
                          ? "border-s-2 border-primary bg-primary/15 text-foreground"
                          : isParent
                            ? "border-s-2 border-dashed border-primary/60 text-foreground hover:bg-accent hover:text-accent-foreground"
                            : "text-foreground hover:bg-accent hover:text-accent-foreground",
                      )}
                    >
                      <Icon className="h-4 w-4 shrink-0" />
                      <span className="truncate">{itemLabel}</span>
                      {ItemBadge && <ItemBadge />}
                    </Link>
                  );
                })}
              </div>
            )}
            {groupedItems.map((group) => {
              const GroupIcon = group.icon;
              const isOpen = openGroupKeys.includes(group.key);
              const hasActiveItem = activeGroupKey === group.key;
              const groupLabel = translateWithFallback(
                t,
                getGroupTranslationKey(group.key),
                group.label,
              );

              return (
                <Collapsible
                  key={group.key}
                  open={isOpen}
                  onOpenChange={(open) => setGroupOpen(group.key, open)}
                >
                  <CollapsibleTrigger asChild>
                    <button
                      type="button"
                      className={cn(
                        "flex min-h-11 w-full items-center gap-3 rounded-md px-3 text-sm font-semibold transition-colors",
                        hasActiveItem
                          ? "bg-accent text-accent-foreground"
                          : "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
                      )}
                      aria-expanded={isOpen}
                      aria-controls={`group-${group.key}`}
                    >
                      <GroupIcon className="h-4 w-4 shrink-0" />
                      <span className="truncate">{groupLabel}</span>
                      {/* Badge removed: count is structural metadata, not user-facing. Future notifications belong on individual items. */}
                      <ChevronDown
                        className={cn(
                          "h-4 w-4 shrink-0 transition-transform",
                          isOpen && "rotate-180",
                        )}
                        aria-hidden="true"
                      />
                    </button>
                  </CollapsibleTrigger>
                  <CollapsibleContent id={`group-${group.key}`}>
                    <div className="mt-1 space-y-1">
                      {group.items.map((item) => {
                        const Icon = item.icon;
                        const localizedHref = localizeHref(item.href, pathname);
                        const active = activeItem?.href === item.href;
                        const isParent = !active && isAncestorOfActive(item.href);
                        const itemLabel = translateWithFallback(
                          t,
                          getRouteTranslationKey(item.name),
                          getLocalizedRouteLabelFallback(item.name, item.label, pathname),
                        );

                        const isItemPending = Boolean(pendingPath && isActiveNavItem(pendingPath, item.href));
                        const ItemBadge = NAV_BADGE_MAP[item.href];
                        return (
                          <Link
                            key={item.href}
                            to={localizedHref as never}
                            aria-current={active ? "page" : isParent ? "true" : undefined}
                            data-pending={isItemPending || undefined}
                            className={cn(
                              "flex min-h-11 items-center gap-3 rounded-md px-3 ps-10 text-sm font-medium transition-colors",
                              active || isItemPending
                                ? "bg-primary/20 text-foreground"
                                : isParent
                                  ? "border-s-2 border-dashed border-primary/60 text-foreground hover:bg-accent hover:text-accent-foreground"
                                  : "text-muted-foreground hover:bg-accent hover:text-accent-foreground",
                            )}
                          >
                            <Icon className="h-4 w-4 shrink-0" />
                            <span className="truncate">{itemLabel}</span>
                            {ItemBadge && <ItemBadge />}
                          </Link>
                        );
                      })}
                    </div>
                  </CollapsibleContent>
                </Collapsible>
              );
            })}
          </div>
        )}
      </nav>
    </aside>
  );
}

export function SystemHeader({
  routes,
  items,
  user,
  onLogout,
  headerExtra,
}: {
  routes: readonly SystemRoute[];
  items: readonly NavItem[];
  user?: SystemUser | null;
  onLogout?: () => void;
  headerExtra?: ReactNode;
}) {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation("common");
  const breadcrumbs = buildBreadcrumbs(routes, pathname);
  const currentLanguage = i18n.language?.split("-")[0] ?? getPathLanguage(pathname) ?? "en";
  const mobileSidebarSide = currentLanguage === "ar" ? "right" : "left";

  return (
    <header className="sticky top-0 z-40 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80">
      <div className="flex min-h-16 items-center gap-3 px-4 py-1 lg:px-6">
        <Sheet>
          <SheetTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="lg:hidden"
              aria-label={t("navigation.toggleMenu", "Toggle navigation menu")}
            >
              <Menu className="h-5 w-5" />
            </Button>
          </SheetTrigger>
          <SheetContent
            side={mobileSidebarSide}
            className="w-80 p-0"
            closeLabel={t("close", "Close")}
          >
            <SheetHeader className="sr-only">
              <SheetTitle>{t("navigation.toggleMenu", "Toggle navigation menu")}</SheetTitle>
              <SheetDescription>
                {t(
                  "navigation.menuDescription",
                  "Open the dashboard navigation links.",
                )}
              </SheetDescription>
            </SheetHeader>
            <SystemSidebar
              items={items}
              pathname={pathname}
              className="border-e-0"
              collapsible={false}
            />
          </SheetContent>
        </Sheet>

	        <BrandLink className="shrink-0 lg:hidden" showText={false} />

        <nav
          aria-label={translateWithFallback(t, "navigation.breadcrumb", "Breadcrumb")}
          className="hidden min-w-0 flex-1 flex-wrap items-center gap-x-2 text-sm text-muted-foreground md:flex"
        >
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            const localizedHref = localizeHref(crumb.href, pathname);
            return (
              <div key={`${crumb.href}-${index}`} className="flex min-w-0 items-center gap-2">
                {index > 0 && (
                  <span className="text-muted-foreground" aria-hidden="true">
                    /
                  </span>
                )}
                <Link
                  to={localizedHref as never}
                  aria-current={isLast ? "page" : undefined}
                  className={cn(
                    // 44px hit area on touch devices via padding, not font size.
                    "min-w-0 max-w-[10rem] truncate text-muted-foreground transition-colors hover:bg-transparent hover:text-foreground hover:underline lg:max-w-[16rem]",
                    "[@media(pointer:coarse)]:inline-flex [@media(pointer:coarse)]:min-h-11 [@media(pointer:coarse)]:items-center [@media(pointer:coarse)]:px-1",
                    isLast && "font-medium text-foreground hover:text-foreground",
                  )}
                >
                  {translateWithFallback(
                    t,
                    crumb.translationKey ?? "",
                    crumb.label,
                  )}
                </Link>
              </div>
            );
          })}
        </nav>

        <div className="ms-auto flex items-center gap-1">
          {headerExtra}
          <SearchTrigger />
          <ThemeMenu />
          <LanguageMenu />
          <UserMenu user={user} onLogout={onLogout} />
        </div>
      </div>
    </header>
  );
}

export function SystemFooter({
  routes,
  user,
}: { routes?: readonly SystemRoute[]; user?: SystemUser | null } = {}) {
  const { pathname } = useLocation();
  const { t } = useTranslation("common");
  const currentYear = new Date().getFullYear();
  const footerItems = routes
    ? buildNavItems(routes, "public")
        .filter((item) => !(user && item.name === "waitlist-signup"))
        .slice(0, 6)
    : [];

  return (
    <footer className="border-t bg-background px-4 py-5 text-sm text-muted-foreground lg:px-6">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <p>
          {translateWithFallback(
            t,
            "footer.copyright",
            `© ${currentYear} ${brand.name}. All rights reserved.`,
            { year: currentYear },
          )}
        </p>
        {footerItems.length > 0 && (
          <nav
            className="flex flex-wrap items-center gap-4"
            aria-label={translateWithFallback(
              t,
              "navigation.footerNavigation",
              "Footer navigation",
            )}
          >
            {footerItems.map((item) => {
              const itemLabel = translateWithFallback(
                t,
                getRouteTranslationKey(item.name),
                getLocalizedRouteLabelFallback(item.name, item.label, pathname),
              );
              const localizedHref = localizeHref(item.href, pathname);
              return (
                <a
                  key={item.href}
                  href={localizedHref}
                  className="inline-flex min-h-11 min-w-11 items-center hover:text-foreground"
                >
                  {itemLabel}
                </a>
              );
            })}
          </nav>
        )}
      </div>
    </footer>
  );
}

function PublicHeader({ routes, user }: { routes: readonly SystemRoute[]; user?: SystemUser | null }) {
  const { pathname } = useLocation();
  const { t } = useTranslation("common");
  const publicItems = buildNavItems(routes, "public");
  // First enabled feature, never a switched-off page.
  const landingPath = useLandingPath();

  return (
    <header className="sticky top-0 z-40 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80">
      <div className="container flex h-16 items-center gap-4">
        <BrandLink />
        <nav
          className="ms-auto hidden items-center gap-2 md:flex"
          aria-label={translateWithFallback(
            t,
            "navigation.publicNavigation",
            "Public navigation",
          )}
        >
          {publicItems.map((item) => {
            const itemLabel = translateWithFallback(
              t,
              getRouteTranslationKey(item.name),
              getLocalizedRouteLabelFallback(item.name, item.label, pathname),
            );
            return (
              <a
                key={item.href}
                href={localizeHref(item.href, pathname)}
                className="rounded-md px-3 py-2 text-sm font-medium text-muted-foreground hover:bg-accent hover:text-accent-foreground"
              >
                {itemLabel}
              </a>
            );
          })}
        </nav>
        <div className="ms-auto flex items-center gap-1 md:ms-0">
          <ThemeMenu />
          <LanguageMenu />
          {user ? (
            <Button asChild>
              <a href={localizeHref(landingPath, pathname)}>
                {translateWithFallback(t, "navigation.dashboard", "Dashboard")}
              </a>
            </Button>
          ) : (
            <Button asChild>
              <a href={localizeHref("/login", pathname)}>
                {translateWithFallback(t, "navigation.login", "Log in")}
              </a>
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}

export function SystemShell({
  children,
  routes: rawRoutes,
  user,
  onLogout,
  variant = "dashboard",
  headerExtra,
}: SystemShellProps) {
  const { pathname } = useLocation();
  const { t } = useTranslation("common");
  // Tooltips never outlive the page they were opened on.
  useCloseTooltipsOnRouteChange(pathname);
  const {
    routes,
    items: dashboardItems,
    groups: sidebarGroups,
    standaloneItems,
    hiddenGroups: sidebarHiddenGroups,
    hiddenGroupsLoading: sidebarPreferencesLoading,
    updateHiddenGroups: updateSidebarHiddenGroups,
    refreshHiddenGroups: refreshSidebarPreferences,
  } = useVisibleRoutes({
    routes: rawRoutes,
    layout: "dashboard",
    user,
    withSidebarPreferences: variant === "dashboard",
  });

  const shellContext = useMemo<SystemShellContextValue>(
    () => ({
      routes,
      user,
      sidebarGroups,
      standaloneItems,
      sidebarHiddenGroups,
      sidebarPreferencesLoading,
      refreshSidebarPreferences,
      updateSidebarHiddenGroups,
    }),
    [
      refreshSidebarPreferences,
      routes,
      sidebarGroups,
      standaloneItems,
      sidebarHiddenGroups,
      sidebarPreferencesLoading,
      updateSidebarHiddenGroups,
      user,
    ],
  );

  if (variant === "public") {
    return (
      <SystemShellContext.Provider value={shellContext}>
        <TooltipProvider>
          <div className="flex min-h-screen flex-col bg-background">
            <PublicHeader routes={routes} user={user} />
            <main className="flex-1">{children}</main>
            <SystemFooter routes={routes} user={user} />
          </div>
        </TooltipProvider>
      </SystemShellContext.Provider>
    );
  }

  const currentRoute = routes.find(
    (candidate) => candidate.path === stripLanguagePrefix(pathname),
  );
  const isFullBleed = currentRoute?.navFullBleed === true;

  return (
    <SystemShellContext.Provider value={shellContext}>
      <TooltipProvider>
        <CommandMenu />
        <div
          className={cn(
            "flex bg-background",
            isFullBleed ? "h-dvh overflow-hidden" : "min-h-screen",
          )}
        >
          <a
            href="#main-content"
            className="sr-only focus:not-sr-only focus:fixed focus:start-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-background focus:px-4 focus:py-2 focus:text-foreground focus:shadow-md"
          >
            {t("a11y.skipToContent", "Skip to main content")}
          </a>
          {/* The sidebar only exists from `lg`; below that the target is not
              rendered, so this link is removed from the tab order there too. */}
          <a
            href={`#${SIDEBAR_NAV_ID}`}
            data-testid="skip-to-navigation"
            className="sr-only hidden focus:not-sr-only focus:fixed focus:start-4 focus:top-16 focus:z-50 focus:rounded-md focus:bg-background focus:px-4 focus:py-2 focus:text-foreground focus:shadow-md lg:block"
          >
            {t("a11y.skipToNavigation", "Skip to page navigation")}
          </a>
          <SystemSidebar
            items={dashboardItems}
            pathname={pathname}
            className="sticky top-0 hidden h-dvh shrink-0 lg:flex"
            persistCollapsed
          />
          <div
            className={cn(
              "flex min-w-0 flex-1 flex-col",
              isFullBleed && "h-dvh overflow-hidden",
            )}
          >
            <SystemHeader
              routes={routes}
              items={dashboardItems}
              user={user}
              onLogout={onLogout}
              headerExtra={headerExtra}
            />
            <main
              id="main-content"
              className={cn(
                isFullBleed
                  ? "min-h-0 flex-1 overflow-hidden"
                  : "flex-1 px-4 py-6 lg:px-6",
              )}
            >
              {children}
            </main>
            {!isFullBleed && <SystemFooter routes={routes} user={user} />}
          </div>
        </div>
      </TooltipProvider>
    </SystemShellContext.Provider>
  );
}

export default SystemShell;
